export function hasUppercase(value) {
  if (!value) return true;
  return /[A-Z]/.test(value);
}

export function hasNumber(value) {
  if (!value) return true;
  return /\d/.test(value);
}

export function hasSpecialChar(value) {
  if (!value) return true;
  return /[!@#$%^&*(),.?":{}|<>]/.test(value);
}
